import { render, staticRenderFns } from "./EventDetailIntroduction.vue?vue&type=template&id=f8e910d8"
import script from "./EventDetailIntroduction.vue?vue&type=script&lang=js"
export * from "./EventDetailIntroduction.vue?vue&type=script&lang=js"
import style0 from "./EventDetailIntroduction.vue?vue&type=style&index=0&id=f8e910d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports